// This icon file is generated automatically.
var LoadingDotOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M8 6a3 3 0 110-6 3 3 0 010 6zm-5.5 5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm2.24 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM11 20a2 2 0 110-4 2 2 0 010 4zm5.32-2.5a2 2 0 110-4 2 2 0 010 4zm2.18-5.18a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-.71-5.11a1 1 0 110-2 1 1 0 010 2zM15.5 4a.5.5 0 110-1 .5.5 0 010 1z", "fill-rule": "evenodd" } }] }, "name": "loading-dot", "theme": "outlined" };
export default LoadingDotOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/LoadingDotOutlined.js
// module id = 3056
// module chunks = 0